import React, { ReactNode } from 'react';

import { Product } from 'models/product';

import { DescriptionProductDetails } from './DescriptionProductDetails';
import { DescriptionShippingAndReturns } from './DescriptionShippingAndReturns';
import { DescriptionSizeAndFit } from './DescriptionSizeAndFit';
import { StyleList } from './StyleList';

/* eslint-disable react/no-danger */

const initialDesktopTab = 'Product details';

export const getProductDescriptionData = ({
  country,
  department,
  formattedModelNumber,
  isCountryDDP,
  isLastOne,
  isSomeSizeLastOne,
  product: { brand, description, formattedSeason, model, sizeFit, storeColor, countryOfOrigin },
  setSizeGuideVisible,
}: {
  country: string;
  department: string;
  formattedModelNumber: string;
  isCountryDDP: boolean;
  isLastOne: boolean;
  isSomeSizeLastOne: boolean;
  product: Product;
  setSizeGuideVisible: (boolean) => void;
}) => {
  const productDescriptions: { mobileInitiallyOpen: boolean; text: ReactNode; title: string }[] = [];

  productDescriptions.push({
    mobileInitiallyOpen: true,
    text: (
      <DescriptionProductDetails
        brandName={brand.name}
        description={description}
        formattedModelNumber={formattedModelNumber}
        formattedSeason={formattedSeason}
        isLastOne={isLastOne}
        isSomeSizeLastOne={isSomeSizeLastOne}
        madeIn={countryOfOrigin}
        model={model}
        styleList={<StyleList sizeFit={sizeFit} storeColor={storeColor} />}
      />
    ),
    title: initialDesktopTab,
  });

  productDescriptions.push({
    mobileInitiallyOpen: false,
    text: <DescriptionSizeAndFit department={department} setSizeGuideVisible={setSizeGuideVisible} />,
    title: 'Size and fit',
  });

  productDescriptions.push({
    mobileInitiallyOpen: false,
    text: <DescriptionShippingAndReturns country={country} isCountryDDP={isCountryDDP} />,
    title: 'Shipping and returns',
  });

  return {
    initialDesktopTab,
    productDescriptions,
  };
};
